// extracted by mini-css-extract-plugin
export var deleteModal = "_hg-0";